import {
  doBulkFetchTicketActions,
  doFetchTicketActions,
  doFetchTicketLinkedResources,
} from 'actions/tickets'
import { doLoadSearchTickets } from 'actions/search'
import { selectCurrentTicket } from 'selectors/tickets'
import {
  selectCurrentTicketSearchResultRawTickets,
  selectSearchResultTicket,
} from 'selectors/search'
import metrics from 'util/metrics'

export function doLoadTicketPage() {
  return (dispatch, getState) => {
    const state = getState()
    const ticket = selectCurrentTicket(state)
    if (ticket && ticket.full) {
      if (!ticket.actions) dispatch(doFetchTicketActions(ticket.id))
      if (!ticket.linkedExternalResources)
        dispatch(doFetchTicketLinkedResources(ticket.id))
    }
    dispatch(doLoadSearchTickets())
  }
}

export function doStartTicketLoadTimer(ticketId) {
  return (dispatch, getState) => {
    const state = getState()
    const ticket = selectSearchResultTicket(state, ticketId)
    const hot = !!(ticket && ticket.full && ticket.actions)
    metrics.startTimer(`ticket-load-${ticketId}`, {
      ticketId,
      metric: 'ticket-load',
      logname: 'main',
      hot,
    })
  }
}

export function doLoadUnloadedSearchTickets() {
  return (dispatch, getState) => {
    const state = getState()
    const tickets = selectCurrentTicketSearchResultRawTickets(state)
    const ticketIds = []
    tickets.forEach(ticket => {
      if (ticket && ticket.full && !ticket.actions) {
        ticketIds.push(ticket.id)
      }
    })
    if (ticketIds.length > 0) dispatch(doBulkFetchTicketActions(ticketIds))
  }
}

export function doForceLoadUnloadedSearchTickets() {
  return (dispatch, getState) => {
    const state = getState()
    const tickets = selectCurrentTicketSearchResultRawTickets(state)
    const ticketIds = []
    tickets.forEach(ticket => {
      if (ticket && ticket.full && !ticket.actions) {
        ticketIds.push(ticket.id)
      }
    })
    if (ticketIds.length > 0)
      dispatch(doBulkFetchTicketActions(ticketIds, true))
  }
}
